import api from "./axios";

export const getFaq = async () => {
  return await api.get("/api/web-api/public/get-faq");
};
